import { criarFinalizador } from '@/uteis/action/tramite/finalizador'
import { criarDestino } from '@/uteis/action/tramite/destinatario'

export const criarTramitacao = (processosTramitacao, dadosSessao, destinatario, remetente, obs, lote) => {
  const destino = criarDestino(destinatario, true)
  var tramite = {
    processos: processosTramitacao,
    executor: criarFinalizador(dadosSessao, true),
    origem: criarFinalizador(dadosSessao, false),
    destino: destino,
    lote: lote,
    atributos: {
      assunto: destinatario.assunto,
      observacao: obs,
      telefoneDestinatario: destinatario.telefoneDestinatario || '',
      estadoDestinatario: destinatario.estadoDestinatario || '',
      cidadeDestinatario: destinatario.cidadeDestinatario || '',
      logradouroDestinatario: destinatario.logradouroDestinatario || '',
      cepDestinatario: destinatario.cepDestinatario || '',
      bairroDestinatario: destinatario.bairroDestinatario || '',
      numeroDestinatario: destinatario.numeroDestinatario || '',
      complementoDestinatario: destinatario.complementoDestinatario || '',

      telefoneRemetente: remetente.telefone || '',
      estadoRemetente: remetente.estado || '',
      cidadeRemetente: remetente.cidade || '',
      logradouroRemetente: remetente.logradouroRemetente || '',
      cepRemetente: remetente.cepRemetente || '',
      bairroRemetente: remetente.bairroRemetente || '',
      numeroRemetente: remetente.numeroRemetente || '',
      complementoRemetente: remetente.complementoRemetente || ''
    },
    recebimentoAutomatico: false
  }

  if (destino.tipoIdentificador !== 'ID') {
    tramite.recebimentoAutomatico = true
  }

  if (destinatario.endereco) {
    tramite.atributos.endereco = destinatario.endereco
  }

  return tramite
}

export const resgatarProtocolo = (instanciaFluxo, dadosSessao) => {
  var tramite = {
    numeroProcesso: instanciaFluxo.processo,
    executor: criarFinalizador(dadosSessao, true),
    origem: instanciaFluxo.ultimaTramitacao.destino,
    destino: criarFinalizador(dadosSessao, false),
    atributos: {
      assunto: 'Estrutura Desativada',
      motivo: 'Estrutura Desativada',
      observacao: '',

      telefoneRemetente: instanciaFluxo.atributos.telefoneDestinatario,
      estadoRemetente: instanciaFluxo.atributos.estadoDestinatario,
      cidadeRemetente: instanciaFluxo.atributos.cidadeDestinatario
    }
  }

  return tramite
}

export const EXPEDIR = 'EXPEDIR'
export const DISTRIBUIR = 'DISTRIBUIR'
export const isExpedicao = (text) => text === EXPEDIR
export const isDestribuicao = (text) => text === DISTRIBUIR
